/**
 * Cyberpunk ASCII Art Header & Monogram Generator
 * Procedural 3-row phosphor ASCII text generator
 */

// 3-row mini font definitions for uppercase alphanumeric characters
const FONT_MAP = {
  A: [' █▀█ ', ' █▀█ ', ' ▀ ▀ '],
  B: [' █▀▄ ', ' █▀▄ ', ' ▀▀  '],
  C: [' █▀▀ ', ' █   ', ' ▀▀▀ '],
  D: [' █▀▄ ', ' █ █ ', ' ▀▀  '],
  E: [' █▀▀ ', ' █▀▀ ', ' ▀▀▀ '],
  F: [' █▀▀ ', ' █▀▀ ', ' ▀   '],
  G: [' █▀▀ ', ' █ █ ', ' ▀▀▀ '],
  H: [' █ █ ', ' █▀█ ', ' ▀ ▀ '],
  I: [' ▀█▀ ', '  █  ', ' ▀▀▀ '],
  J: ['  █  ', '  █  ', ' ▀▀  '],
  K: [' █▄▀ ', ' █ █ ', ' ▀ ▀ '],
  L: [' █   ', ' █   ', ' ▀▀▀ '],
  M: [' █▄█ ', ' █ █ ', ' ▀ ▀ '],
  N: [' █▀▄ ', ' █ █ ', ' ▀ ▀ '],
  O: [' █▀█ ', ' █ █ ', ' ▀▀▀ '],
  P: [' █▀█ ', ' █▀▀ ', ' ▀   '],
  Q: [' █▀█ ', ' █▀█ ', ' ▀▀█ '],
  R: [' █▀█ ', ' █▀▄ ', ' ▀ ▀ '],
  S: [' █▀▀ ', ' ▀▀█ ', ' ▀▀▀ '],
  T: [' ▀█▀ ', '  █  ', '  ▀  '],
  U: [' █ █ ', ' █ █ ', ' ▀▀▀ '],
  V: [' █ █ ', ' █ █ ', '  ▀  '],
  W: [' █ █ ', ' █▄█ ', ' ▀ ▀ '],
  X: [' ▀▄▀ ', '  █  ', ' ▀ ▀ '],
  Y: [' █ █ ', '  █  ', '  ▀  '],
  Z: [' ▀▀█ ', ' ▄▀  ', ' ▀▀▀ '],
  '0': [' █▀█ ', ' █ █ ', ' ▀▀▀ '],
  '1': ['  █  ', '  █  ', ' ▀▀▀ '],
  '2': [' ▀▀█ ', ' █▀▀ ', ' ▀▀▀ '],
  '3': [' ▀▀█ ', '  ▀█ ', ' ▀▀▀ '],
  '4': [' █ █ ', ' ▀▀█ ', '   ▀ '],
  '5': [' █▀▀ ', ' ▀▀█ ', ' ▀▀▀ '],
  '6': [' █▀▀ ', ' █▀█ ', ' ▀▀▀ '],
  '7': [' ▀▀█ ', '   █ ', '   ▀ '],
  '8': [' █▀█ ', ' █▀█ ', ' ▀▀▀ '],
  '9': [' █▀█ ', ' ▀▀█ ', ' ▀▀▀ '],
  ' ': ['     ', '     ', '     '],
  '-': ['     ', ' ▀▀▀ ', '     '],
  '_': ['     ', '     ', ' ▀▀▀ '],
  '.': ['     ', '     ', '  ▀  '],
  ':': ['  ▀  ', '     ', '  ▀  '],
};

export function generateAsciiBanner(text = '', maxChars = 12) {
  if (!text) return '';
  const sanitized = text.toUpperCase().slice(0, maxChars);
  const rows = ['', '', ''];

  for (const ch of sanitized) {
    const glyph = FONT_MAP[ch] || FONT_MAP[' '];
    rows[0] += glyph[0];
    rows[1] += glyph[1];
    rows[2] += glyph[2];
  }

  return rows.join('\n');
}

export function generateAsciiMonogram(text = '') {
  if (!text) return '[]';
  const char = text.trim()[0]?.toUpperCase() || 'M';
  const glyph = FONT_MAP[char] || FONT_MAP['M'];
  return glyph.join('\n');
}
